import { renderDefinedTrue } from "@/utils/react-conditional";
import React from "react";

// The 20px rhythm between icon / sentence / children comes from `space-y-5`
// here (and between title and this block from PopupBackground), not from
// margins on each child.
export const PopupContent = React.memo(function PopupContent(props: {
  emoj?: string;
  /** Resolved image URL (e.g. an imported asset), not a bare filename. */
  image?: string;
  sentence?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="space-y-5">
      {renderDefinedTrue(props.image, () => (
        <div className="inline-block size-22.5">
          <img className="h-auto w-full" src={props.image} alt="" />
        </div>
      ))}
      {renderDefinedTrue(props.emoj, () => (
        <div className="text-[90px] leading-none">{props.emoj}</div>
      ))}
      {renderDefinedTrue(props.sentence, () => (
        <p className="text-body-lg/[inherit] font-normal text-body-text">
          {props.sentence}
        </p>
      ))}
      <div>{props.children}</div>
    </div>
  );
});
